import React from "react";
import NavbarFilterCatchment from "./NavbarFilterCatchment";
import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableListCatchment from "@/pages/CatchmentPage/components/TableListCatchment";

export type CatchmentCampaignPageProps = {
  isLoading: any;
  isError: boolean;
  people: any;
  branches: any;
  tagsMarketing: any;
  campaigns: any;
  exportData: any;
  branchId: string;
  createUser: (user: any) => void;
  selectBranch: (branch: any) => void;
  selectedBranch: any;
  formValues: any;
  dispatch: any;
  selectedCompany: any;
  companies: any;
};

const CatchmentCampaignPage: React.FC<CatchmentCampaignPageProps> = ({
  isLoading,
  isError,
  people,
  branches,
  tagsMarketing,
  campaigns,
  exportData,
  createUser,
  branchId,
  selectBranch,
  selectedBranch,
  selectedCompany,
  companies,
  formValues,
  dispatch,
}) => {
  return (
    <>
      <NavbarFilterCatchment
        selectBranch={selectBranch}
        selectedCompany={selectedCompany}
        companies={companies}
        selectedBranch={selectedBranch}
        branches={branches}
        branchId={branchId}
        optionsTagsMarketing={tagsMarketing}
        campaigns={campaigns}
        exportData={exportData}
        formValues={formValues}
        dispatch={dispatch}
      />
      {isLoading && (
        <div className="flex justify-center items-center h-90 mt-20">
          <FontAwesomeIcon icon={faLoader} spin className="text-6xl" />
        </div>
      )}
      {isError && <p>Error fetching data</p>}
      {!isLoading && !isError && people?.length === 0 && (
        <div className="flex flex-col items-center justify-center h-80 mt-20 text-center">
          {/* Mensaje */}
          <h3 className="mt-6 text-lg font-semibold text-gray-700">
            No se encontraron leads
          </h3>
          <p className="mt-2 text-gray-500 max-w-sm">
            Aún no tienes registros de leads en esta vista. Intenta cambiar los
            filtros.
          </p>
        </div>
      )}

      {!isLoading && !isError && people?.length > 0 && (
        <TableListCatchment
          branchId={branchId}
          people={people}
          createUser={(select) => createUser?.(select)}
        />
      )}
    </>
  );
};

export default CatchmentCampaignPage;
